"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by mariam.melkonyan on 5/3/17.
 */
var ChartType;
(function (ChartType) {
    ChartType[ChartType["BAR"] = 0] = "BAR";
    ChartType[ChartType["COLUMN"] = 1] = "COLUMN";
    ChartType[ChartType["AREA"] = 2] = "AREA";
    ChartType[ChartType["VERTICAL_AREA"] = 3] = "VERTICAL_AREA";
    ChartType[ChartType["LINE"] = 4] = "LINE";
    ChartType[ChartType["VERTICAL_LINE"] = 5] = "VERTICAL_LINE";
    ChartType[ChartType["PIE"] = 6] = "PIE";
    ChartType[ChartType["SPEEDOMETER"] = 7] = "SPEEDOMETER";
    ChartType[ChartType["RADAR"] = 8] = "RADAR";
    ChartType[ChartType["COMBINATION"] = 9] = "COMBINATION";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
//# sourceMappingURL=chart-type.model.js.map